require("@fancyapps/fancybox/dist/jquery.fancybox.min.js");
require("@fancyapps/fancybox/dist/jquery.fancybox.min.css");